<script setup>
import Dialog from "primevue/dialog";

const props = defineProps({
  visible: { type: Boolean, default: false },
  main_classes: { type: Array, default: () => [] },
  dialog_classes: { type: Array, default: () => [] },
});
const emit = defineEmits(["update:visible"]);
</script>

<template>
  <Dialog
    :visible="props.visible"
    @update:visible="emit('update:visible', $event)"
    :modal="true"
    :draggable="false"
    :closable="true"
    :pt="{
      root:    { class: ['ravo-modal', ...props.main_classes] },
      header:  { class: 'ravo-modal-header' },
      content: { class: 'ravo-modal-body' },
      footer:  { class: 'ravo-modal-footer' },
    }"
  >
    <template #header><slot name="title" /></template>
    <slot name="body" />
    <template #footer><slot name="footer" /></template>
  </Dialog>
</template>
